import { SupportedTags } from '../platform';

export const ENDPOINTS = {
    [`${SupportedTags.APPAREL_ORDER}_development`]: 'https://order.wooter.co',
    [`${SupportedTags.APPAREL_ORDER}_production`]: 'https://wooter.com',
};
